import React from "react";

import { Avatar, Divider } from "@mui/material";

import { getAcronym, isEmpty as isStringEmpty } from "../../../../utils/string";

import Job from "../../assets/images/job.png";
import Location from "../../assets/images/location.png";

import "./RecognitionSearchBarResult.css";

export default function RecognitionSearchBarResult({
  id,
  job,
  name,
  location,
  profilePictureUrl,
  onClick = () => {},
}) {
  return (
    <div
      className="recognition-search-bar-result-wrapper"
      onClick={() => onClick(id)}
    >
      <div className="avatar-wrapper">
        <Avatar
          src={profilePictureUrl}
          sx={{
            width: 40,
            height: 40,
            fontSize: "16px",
            bgcolor: "rgb(90,156,213)",
          }}
        >
          {getAcronym(name)}
        </Avatar>
      </div>

      <div className="details-wrapper">
        <span className="title">{name}</span>

        <div className="info-wrapper">
          <div className="info">
            <img src={Job} alt="Job" />
            <span>{!isStringEmpty(job) ? job : "-"}</span>
          </div>

          <Divider orientation="vertical" sx={{ height: "14px" }} />

          <div className="info">
            <img src={Location} alt="Location" />
            <span>{!isStringEmpty(location) ? location : "-"}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
